import type { Service } from '../../posApi/services/service'
import type { User } from '../../usersApi/users/user'

export class AppointmentItem {
    appointmentItemId: string
    createdAt?: Date
    updatedAt?: Date
    appointmentId: string
    serviceId: string
    label: string
    userId: string
    user?: User
    service?: Service
    // DESDE 26/07/2026 é um ESPELHO de comissionPrice (mesmo valor de venda apurado). Antes disso guardava o
    // preço de tabela do serviço, então registros antigos ainda podem divergir. Mantido só por compatibilidade —
    // PODE SER REMOVIDO com segurança quando ninguém mais referenciar. Use comissionPrice em código novo.
    price: number
    comissionFixed: number
    comissionPercentage: number // valor em R$ da comissão percentual (NÃO é o percentual)
    comissionCosts: number
    comissionFeeDebt: number
    // valor de VENDA apurado para o item (base de cálculo da comissão) — não é o valor da comissão.
    // A comissão é comissionFixed + comissionPercentage - comissionCosts - comissionFeeDebt.
    comissionPrice: number
    comissionPriceSource: 'pos' | 'price'
    // alguma taxa do atendente (% / fixo / custos) veio da comissão personalizada do profissional, e não do
    // cadastro do serviço — herança campo a campo, os valores efetivos já estão nos campos comission* acima
    comissionRateCustomized?: boolean
    comissionCanceled: boolean
    parentServicesOnInvoicesId?: string
    invoiceId: string
    invoiceIdType: 'auto' | 'referenced'
    groupId?: string
    groupPos?: string
    groupTotal?: number
}
